module.exports = __webpack_public_path__ + "img/test1.710b625c.jpg";